import React, {useContext} from 'react'
import {Container, Row, Col, Spinner} from "react-bootstrap"
import CarItem from '../components/Cars/CarItem.jsx'
import {StateContext} from "../context/GlobalState.jsx";
import {GetText} from "../context/text.js";
import {Helmet} from "react-helmet";

function Cars() {
    let {cars} = useContext(StateContext);


    let text = GetText();

    return (
        <div>
            <Helmet>
                <title>{text.Cars.title + ' - ' + text.Header.name} - zapauto.com.ua</title>
                <meta name="description" content={text.Cars.title}/>
            </Helmet>
            <Container>
                <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>

                        <h3><b>{text.Cars.title}:</b></h3>

                        <div className="cars">

                            <Container>
                                <Row>

                                    {cars.length > 0 ? cars.map((car, i) => <Col key={i} xs={12} sm={6} md={3}><CarItem key={i} car={car}/></Col>) :  <div className="center-text items padTop"><Spinner animation="border" /></div>}
                                </Row>
                            </Container>
                        </div>


                    </Col>
                </Row>
            </Container>
        </div>
    )
}


export default Cars





